// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import dotsHorizontalIcon from "@/assets/icons/dots-horizontal.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type DotsHorizontalIconProps = Omit<IconProps, "name">;

export function DotsHorizontalIcon(props: DotsHorizontalIconProps): React.ReactNode {
  return <Icon name={dotsHorizontalIcon} {...props} />;
}
